import { invoicesListTypes } from './actionTypes';

export const getInvoicesList = (payload: any) => ({
  type: invoicesListTypes.GET_INVOICES_LIST,
  payload,
});

export const getInvoicesListSuccess = (payload: any) => ({
  type: invoicesListTypes.GET_INVOICES_LIST_SUCCESS,
  payload,
});

export const getInvoicesListFail = (error: any) => ({
  type: invoicesListTypes.GET_INVOICES_LIST_FAIL,
  payload: error,
});

export const getMilestoneConfigIN = ()=>{
  return{
    type: invoicesListTypes.GET_MILESTONESCONFIG_IN,
  }
}

export const getMilestoneConfigINSuccess = (payload:any)=>{
  return{
    type: invoicesListTypes.GET_MILESTONESCONFIG_IN_SUCCESSS,
    payload,
  }
}

export const getMilestoneConfigINFail = (payload:any)=>{
  return{
    type: invoicesListTypes.GET_MILESTONESCONFIG_IN_FAIL,
    payload,
  }
}
